import { render } from "./QrCodeN.vue?vue&type=template&id=cdb483b0"
import script from "./QrCodeN.vue?vue&type=script&lang=js"
export * from "./QrCodeN.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pixsmart_site_v2\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__